import { render, staticRenderFns } from "./ControlSelect.vue?vue&type=template&id=24121c9b"
import script from "./ControlSelect.vue?vue&type=script&lang=js"
export * from "./ControlSelect.vue?vue&type=script&lang=js"
import style0 from "./ControlSelect.vue?vue&type=style&index=0&id=24121c9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports